<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import NDIComponent from "@/component/project/NDIComponent.vue";

@Component({
  components: {NDIComponent, NavBar}
})
export default class NDIView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <NDIComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>